import React from 'react';
import { AuthContext } from '../components/Authorizer/Authorizer';

export const useAuth = () => {
    return React.useContext(AuthContext);
};
